import { render } from "./HistoricView.vue?vue&type=template&id=bdec05de&ts=true"
import script from "./HistoricView.vue?vue&type=script&lang=ts"
export * from "./HistoricView.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__